/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import sharedStyles from '../../app/styles.js';
import {
    loadLtiItemsIfNeeded,
    publishLtiItemAsComposition,
    unpublishLtiItemAsComposition,
    createLtiItem,
    //duplicateLtiItem,
    deleteLtiItem,
} from '../../store/lti/lti.js';
import { previewElearning } from '../../store/preview/preview.js';
import { navigate } from '../../store/route/route.js';
import { translate } from '../../helpers/translate.js';
import { renderTimestamp } from '../../helpers/controls.js';
import '@lit-labs/virtualizer';
import '@polymer/app-layout/app-layout.js';
import '@vaadin/context-menu/theme/material/vaadin-context-menu.js';
import '@material/web/fab/fab.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-search-input.js';
import '../shared/sdb-loading.js';
import '../shared/sdb-status-message.js';
import '../shared/sdb-dialog.js';

@customElement('sdb-lti-item-list')
class SdbLtiItemList extends connect(store)(LitElement) {

    @state()
    accessor ltiItems;

    @state()
    accessor total;

    @state()
    accessor search;

    @state()
    accessor isLoadingFirstTime;

    @state()
    accessor user;

    @state()
    accessor args;

    get downloadLtiItemsCsvUrl() {
        return `${this.settings.ltiConsumerApi}/api/1.0/export/ltiitems/${this.portalId}`;
    }

    get newName() {
        return document.getElementById('lti_new_name');
    }

    stateChanged(state) {
        this.ltiItems = state.lti.list || [];
        this.total = state.lti.total;
        this.search = state.lti.search;
        this.isLoadingFirstTime = state.lti.status === 'loading' && state.lti.page === -1;
        this.user = state.auth.user;
        this.settings = state.env.settings;
        this.portalId = state.env.portalIdentifier;
        this.hasGlobalId = state.env.hasGlobalId;
    }

    static styles = [
        sharedStyles,
        css`
            :host {
                max-width: var(--tcg-content-max-width);
                width: 100%;
            }

            .right-nav-bar {
                display:flex;
                align-items: center;
                justify-content: space-between;
            }

            sdb-search-input {
                flex-grow: 1;
            }

            sdb-content-iconbutton {
                margin-left: 10px;
            }

            #lti_items_list {
                contain: none !important; /* lit-virtualizer hack */
            }

            sdb-content-listitem {
                width: 100%; /* lit-virtualizer screws this up */
            }



            .no-results {
                width: 100%;
                max-width: var(--tcg-content-max-width);
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            #no_results_img {
                width: 400px;
                height: 400px;
                background-color: var(--tcg-secondary-background-color);
            }
        `,
    ];

    render() {
        if (this.isLoadingFirstTime) {
            return html`<sdb-loading></sdb-loading>`;
        }

        return html`
            <sdb-layout-60-40>
                <sdb-nav-titlebar slot="left">
                    <span>${translate('headerLtiItems')}</span>
                    <span ?hidden=${!this.total}>&nbsp;(${this.total})</span>
                </sdb-nav-titlebar>
                <div class="right-nav-bar" slot="right">
                    <sdb-search-input
                        placeholder=${translate('search')}
                        value=${this.search}
                        @search=${(e) => { store.dispatch(loadLtiItemsIfNeeded({ search: e.detail.searchText, reload: true })); }}>
                    </sdb-search-input>
                    <a href=${this.downloadLtiItemsCsvUrl}>
                        <sdb-content-iconbutton icon="fal fa-file-csv" size="24"></sdb-content-iconbutton>
                    </a>
                </div>
            </sdb-layout-60-40>
            <sdb-layout-100>
                ${!this.total
                    ? html`<sdb-status-message label=${translate('noLtiItemsFound')}></sdb-status-message>`
                    : html`
                        <sdb-content-list separator>
                            <lit-virtualizer
                                id="lti_items_list"
                                .items=${this.ltiItems}
                                .renderItem=${(ltiItem, index) => this._renderLtiItemListItem(ltiItem, index)}
                                .scrollTarget=${document}>
                            </lit-virtualizer>
                        </sdb-content-list>
                    `
                }
                <md-fab @click=${()=> { this._openDialog('add', null); }}>
                    <sdb-content-icon
                        slot="icon"
                        icon="fal fa-plus"
                        size="24">
                    </sdb-content-icon>
                </md-fab>
            </sdb-layout-100>

            <sdb-dialog
                type="confirm"
                id="publish_dialog"
                heading=${translate('publishHeadingLtiItem')}
                body=${translate('publishBodyLtiItem')}
                confirmCaption=${translate('publish')}
                @confirm=${(e) => { store.dispatch(publishLtiItemAsComposition({ item: e.detail.args })); }}>
            </sdb-dialog>

            <sdb-dialog
                type="confirm"
                id="unpublish_dialog"
                heading=${translate('unpublishHeadingLtiItem')}
                body=${translate('unpublishBodyLtiItem')}
                confirmCaption=${translate('unpublish')}
                @confirm=${(e) => { store.dispatch(unpublishLtiItemAsComposition({ item: e.detail.args })); }}>
            </sdb-dialog>

            <sdb-dialog
                type="confirm"
                id="delete_dialog"
                heading=${translate('deleteHeadingtiItem')}
                confirmCaption=${translate('delete')}
                @confirm=${(e) => { store.dispatch(deleteLtiItem({ id: e.detail.args })); }}>
            </sdb-dialog>

            <sdb-dialog
                type="form"
                id="add_dialog"
                heading=${translate('createHeadingtiItem')}
                confirmCaption=${translate('create')}
                @confirm=${() => { store.dispatch(createLtiItem({ name: this.newName.value })); this.newName.value = ''; }}
                .bodyRenderer=${() => html`
                    <paper-input
                        id="lti_new_name"
                        transparent
                        style="width: 500px;"
                        label=${translate('name')}>
                    </paper-input>
                `}>
            </sdb-dialog>
        `;
    }

    firstUpdated() {
        this.dispatchEvent(
            new CustomEvent('fullscreen', {
                bubbles: true,
                composed: true,
                detail: {
                    fullscreen: false,
                },
            }),
        );
    }

    _renderLtiItemListItem(ltiItem, index) {
        store.dispatch(loadLtiItemsIfNeeded({ index }));

        const menuItems = [
            {
                text: translate('publish'),
                action: () => this._openDialog('publish', ltiItem),
                hidden: this.hasGlobalId,
                disabled: ltiItem.elearningType === 0,
            },
            {
                text: translate('unpublish'),
                action: () => this._openDialog('unpublish', ltiItem),
                hidden: this.hasGlobalId,
                disabled: ltiItem.elearningType === 1,
            },
            {
                text: translate('preview'),
                action: () => store.dispatch(previewElearning({ item: ltiItem })),
            },
        ].filter(item => !item.hidden);

        return html`
            <sdb-content-listitem
                icon="fal fa-square-l"
                .headline=${ltiItem.title}
                .subtitle=${this._getSubtitle(ltiItem)}
                @click=${()=> { store.dispatch(navigate(`ltiitem/${ltiItem.targetId}`)); }}>

                <sdb-content-chipbar slot="chipbar">
                    <sdb-content-chip label="catalogus" ?hidden=${ltiItem.elearningType !== 0}></sdb-content-chip>
                </sdb-content-chipbar>

                <vaadin-context-menu
                    slot="secondaryAction"
                    open-on="click"
                    .items=${menuItems}
                    @item-selected=${(e) => {
                        e.stopPropagation();
                        e.detail.value?.action?.();
                    }}>
                    <sdb-content-iconbutton icon="fal fa-ellipsis-vertical"></sdb-content-iconbutton>
                </vaadin-context-menu>

            </sdb-content-listitem>
        `;
    }

    _getSubtitle(ltiItem) {
        var s = `${translate('lastModified')}: ${renderTimestamp(ltiItem.lastModified)}`;
        if (ltiItem.supplier && ltiItem.supplier.supplierKey) {
            s += ` | ${ltiItem.supplier.name}`;
        }
        if (ltiItem.description) {
            s += ` | ${ltiItem.description}`;
        }
        return s;
    }

    _openDialog(action, args) {
        this.renderRoot.querySelector(`#${action}_dialog`).open(args);
    }
}

